import axios from 'axios';
import logger from '../common/helpers/logger/logger';
import config from '../common/config';
import { USER_AGENT } from '../common/helpers/constants';
import { DDListingsResponse } from '../lib/ddListingTypes';

export const fetchDDListings = async (
  propertyId: string | number,
): Promise<DDListingsResponse | null> => {
  try {
    const response = await axios.get<DDListingsResponse>(
      `${config.ddListingsApiBaseUrl}/v5/listings`,
      {
        headers: {
          'User-Agent': USER_AGENT,
        },
        params: {
          locale: 'th',
          property_id: propertyId,
        },
        timeout: 5000,
      },
    );

    if (!response.data?.listings?.length) {
      return null;
    }

    return response.data;
  } catch (error) {
    logger.logError(
      'ddListings.fetchDDListings',
      'Error fetching DD Property listings',
      {
        propertyId,
        error: error?.message,
        baseUrl: config.ddListingsApiBaseUrl,
      },
    );
    return null;
  }
};
